import { Grid, makeStyles, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import {
  InsuranceInformation,
  InsuranceInformationBaseStore,
  InsuranceInformationReviewBaseStore,
  InsuranceInformationReviewForm,
  renderContentPropertyDetailsContent,
} from '@roc/feature-insurance-review';
import { useUserStore } from '@roc/feature-app-core';
import { insertIf } from '@roc/feature-utils';
import { Document } from '@roc/feature-types';
import { Tabs } from '@roc/ui';
import { InsuranceQuoteStatusChip } from 'libs/feature-borrower-review/src/components/InsuranceQuoteStatusChip';
import { PropertiesSummary } from './propertyDetails';

export type InsuranceInformationAndReviewProps = {
  insuranceInformationStore: InsuranceInformationBaseStore;
  insuranceInformationReviewStore: InsuranceInformationReviewBaseStore;
  loanId: string;
  document: Document;
  handleClose: () => void;
};

const styles = makeStyles(() => ({
  tab: {
    // borderRight: 'none !important',
    // borderTop: 'none !important',
    // borderLeft: 'none !important',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '& .MuiTab-root': {
      maxWidth: '100% !important',
    }
  },
  container: {
    backgroundColor: 'white',
    display: 'block'
  },
  title: {
    margin: '10px 0px 0px 20px',
    display: 'flex',
    alignItems: 'center'
  },
}));

export const InsuranceInformationAndReview = observer(
  (props: InsuranceInformationAndReviewProps) => {
    const { insuranceInformationStore, insuranceInformationReviewStore, loanId, document, handleClose } = props;
    const classes = styles();
    const { userStore } = useUserStore();

    const [selectedTab, setSelectedTab] = useState(0);
    const onTabChange = (e, index) => setSelectedTab(index);
    const [state, setState] = useState({
      tab: 0,
      uploadFloodCert: false,
      override: false
    });

    const TABS = [
      {
        label: 'Summary',
      },
      ...insertIf(userStore.isNportalUser, [{
        label: 'Insurance Review',
      }]),
      ...insertIf(userStore.isNportalUser, [{
        label: 'Property Review',
      }]),
    ];

    const renderStatusChip = () => {
      return (
        <>
          {insuranceInformationReviewStore.insuranceAutomationStatus &&
            <Grid item xs={12} container spacing={1} className={classes.title}>
              <Grid item>
                <Typography variant="body1">Status: </Typography>
              </Grid>
              <Grid item>
                <InsuranceQuoteStatusChip properties={{ label: insuranceInformationReviewStore.automationStatusMappingValue, status: insuranceInformationReviewStore.insuranceAutomationStatus }} />
              </Grid>
            </Grid>
          }
        </>
      )
    }

    const tabContentRenderer = (tab) => {
      if (tab === 0) {
        return (
          <InsuranceInformation
            store={insuranceInformationStore}
            loanId={loanId}
            taskId={document?.taskId?.toString()}
            document={document}
            handleClose={handleClose}
            showTitle={false}
          />
        )
      }
      else if (tab === 1) {
        return (
          <Grid container className={classes.container}>
            {renderStatusChip()}
            <Grid item xs={12}>
              <InsuranceInformationReviewForm
                store={insuranceInformationReviewStore}
                loanId={loanId}
                document={document}
                onClose={handleClose}
                showTitle={false}
              />
            </Grid>
          </Grid>
        )
      }
      else if (tab === 2) {
        return (
          <Grid container className={classes.container}>
            {renderStatusChip()}
            <Grid item xs={12}>
              {(state.uploadFloodCert || state.override) ?
                renderContentPropertyDetailsContent(state, setState)
                :
                <PropertiesSummary
                  document={document}
                  setUploadMode={(value) => setState(prev => ({ ...prev, uploadFloodCert: value }))}
                  setOverrideMode={(value) => setState(prev => ({ ...prev, override: value }))}
                />
              }
            </Grid>
          </Grid>
        )
      }
    }

    return (
      <>
        {TABS.length > 1 &&
          <Tabs
            tabs={TABS}
            selectedTab={selectedTab}
            onTabChange={onTabChange}
            className={classes.tab}
          />
        }
        {tabContentRenderer(selectedTab)}
      </>
    );
  });
